// Metered AI display units. Pro accounts include 3,750 credits per UTC month.
export const TRACE_CREDITS = Object.freeze({
  creditsPerDollar: 750,
  proMonthlyIncluded: 3750,
  usageMultiplier: 1.3,
});

export function creditsForAiCost(usd) {
  if (!Number.isFinite(usd) || usd < 0) return null;
  if (usd === 0) return 0;
  return Number((usd * TRACE_CREDITS.usageMultiplier * TRACE_CREDITS.creditsPerDollar).toFixed(8));
}

// Initial budgeting assumptions, not measured costs or guaranteed quotes.
export const SATIN_COST_ESTIMATES_USD = Object.freeze({
  simple: 0.2,
  medium: 0.5,
  detailed: 1,
});

// Cost of one completed job, measured from the production usage ledger (2026-09).
// Measure per job (requestId), never per provider response: a satin layer averages
// five calls once refinements and retries are counted, so per-response figures
// understate it roughly eightfold.
// Retrace and Modify are a single fixed-size image call, hence one exact number.
// Satin scales with shape complexity over a genuinely wide range (observed 21 to
// 3,272 credits, i.e. up to $4.36 for one layer), so it carries p25/p75 bounds
// and must always be quoted as a range. Keys match offerCreditTopUp tool names.
export const FEATURE_RUN_COSTS = Object.freeze({
  Retrace: Object.freeze({credits: 135, noun: "retraces", service: "retrace"}),
  Modify: Object.freeze({credits: 135, noun: "edits", service: "modify"}),
  Satin: Object.freeze({credits: 1450, creditsLow: 500, noun: "satin layers", service: "satin-ai"}),
});

// Range of whole runs a credit balance buys: low end assumes costly jobs, high end
// cheap ones. low === high for the fixed-cost tools.
export function runsForCredits(credits, tool) {
  const cost = FEATURE_RUN_COSTS[tool];
  if (!cost || !Number.isFinite(credits) || credits <= 0) return null;
  const low = Math.floor(credits / cost.credits);
  return low > 0 ? {low, high: Math.floor(credits / (cost.creditsLow ?? cost.credits))} : null;
}

// Charge already includes the markup. Never apply it a second time.
export function creditsForCustomerCharge(usd) {
  return Number.isFinite(usd) && usd >= 0
    ? Number((usd * TRACE_CREDITS.creditsPerDollar).toFixed(8)) : null;
}
